import { render, staticRenderFns } from "./ReviewOption.vue?vue&type=template&id=5489597b&scoped=true"
import script from "./ReviewOption.vue?vue&type=script&lang=js"
export * from "./ReviewOption.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/review_rating/review_content.css?vue&type=style&index=0&id=5489597b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489597b",
  null
  
)

export default component.exports